import { Dots, Rule, Spacer } from "./ui"

const Divider = ({ layout, blockStyles }) => {
  switch (layout) {
    case "dots":
      return <Dots blockStyles={blockStyles} />
    case "spacer":
      return <Spacer />
    case "rule":
    default:
      return <Rule blockStyles={blockStyles} />
  }
}

export default Divider
